import {
  Button,
  Typography,
  Box,
  Paper,
  Container,
  Modal,
  styled,
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { PDFViewer } from "@react-pdf/renderer";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { IconContext } from "react-icons";
import { TfiDownload } from "react-icons/tfi";
import { useAppSelector } from "../../_app";
import { Notify, Utils } from "../../utils";
import { NavLink } from "react-router-dom";
import {
  EmployeeService,
  PayrunService,
  TellBossService,
} from "../../_service";
import { CommonModal, CustomButton, Loader } from "../../components";
import { useEffect, useMemo, useState } from "react";
import PayrunPdf from "../../components/pdfs/PayrunDocuments";
import { CreatePayrunModal } from "../../components";
import FinalizedPayrun from "../../components/payrun/FinalizedPayrun";
import { Constant } from "../../config";
import { Colors } from "../../config/color";
import moment from "moment";
import useFirebaseAnalytics from "../../hooks/useFirebaseAnalytics";
import merge from "lodash.merge";
import { TailSpin } from "react-loader-spinner";
import { da } from "date-fns/locale";
import { microAgent } from "../../newRelicConfig";
import PayrunInProcessBlock from "./PayrunBlock";
import PayrunBlock from "./PayrunBlock";
import SendToBossModal from "../../components/modals/SendToBossModal";
import { BsClipboard2MinusFill } from "react-icons/bs";
import CustomTooltip from "../../components/CustomTooltip";
import { PulsingIcon } from "../users/styles";
// convertToDateString

const PayrunItem = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginTop: "20px",
  padding: "24px",
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    padding: "16px",
  },
}));

const PayslipContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  width: "120px",
  border: "1px solid #e5e7eb",
  borderRadius: "6px",
  overflow: "hidden",
  transition: "transform 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
  },
}));

const Title = styled(Box)(() => ({
  background: "#f3f4f6",
  textAlign: "center",
  padding: "8px",
  fontSize: "14px",
  fontWeight: 500,
  color: "#4b5563",
}));

const Value = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "56px",
  fontSize: "24px",
  fontWeight: 600,
  color: "#1f2937",
}));

const Link = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "36px",
  fontSize: "14px",
  fontWeight: 500,
  borderTop: "1px solid #e5e7eb",
  color: "#2563eb",
  cursor: "pointer",
  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: "#f3f4f6",
  },
}));

function Payrun() {
  const navigate = useNavigate();
  const theme = useTheme();
  const defaultCompanyId = useAppSelector(
    (state) => +state.user.defaultCompnayId
  );

  const hasViewAccess = useMemo(
    () => Utils.checkAccess("pay_run", "pay_run", "view"),
    []
  );
  const hasAddEditAccess = useMemo(
    () => Utils.checkAccess("pay_run", "pay_run", "add/edit"),
    []
  );

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  // const [accountingInfoData, setAccoutingInfoData] = useState<any>({});
  const [open, setOpen] = useState(false);
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [activeDataModal, setActiveDataModal] = useState<string | null>(null);
  const [pdfModal, setPdfModal] = useState<boolean>(false);
  const [pdfViewModal, setPdfViewModal] = useState<boolean>(false);
  const [currentPayrun, setCurrentPayrun] = useState<null | number>(null);
  const [finalizedData, setFinalizedData] = useState<any[]>([]);
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [dateToApprove, setDateToApprove] = useState("");
  const [isAlreadySentToTellboss, setIsAlreadySentToTellboss] =
    useState<boolean>(false);
  const [cpfReturnStatus, setCpfReturnStatus] = useState<any>(null);

  const [dataView, setDataView] = useState<any[]>([]);
  const companyId = useAppSelector((state) => state.user.defaultCompnayId);
  const companyName = useAppSelector((state) => state.user.defaultCompany);

  const [showCPFNotFinalsedError, setShowCPFNotFinalsedError] = useState(null);
  const [isShowMore, setIsShowMore] = useState(false);

  const [openSendToTellBossModal, setOpenSendToTellBossModal] =
    useState<boolean>(false);

  const logFirebaseEvent = useFirebaseAnalytics();

  const user = useAppSelector((state) => state.user);
  const currentPayrunDate = useAppSelector(
    (state) => state.user.current_payrun_date
  );

  const [year, setYear] = useState(currentPayrunDate?.split("-")?.[0]);

  const [showFetchButton, setShowFetchButton] = useState(true);

  const get = async () => {
    try {
      setLoading(true);
      const res1 = await PayrunService._getPayrunByCompany(
        defaultCompanyId,
        year
      );
      // const res2 = await PayrunService._getAllAccountingInfo(companyId,)

      // setData(res1);

      setData((prevState: any) => merge({}, prevState, res1));

      // if(Object.keys(res1?.payrun_finalized_payslips || {})?.length || Object.keys(res1?.pending_payslips || {})?.length){
      //   setData((prevState:any) => merge({}, prevState, res1));
      // }

      // if(!Object.keys(res1?.payrun_finalized_payslips || {})?.length) {
      //   setShowFetchButton(false);
      // }

      let isPayrunReady = Object.entries(res1?.pending_payslips)?.[0]?.[1]
        ?.is_payrun_ready;
      let isProceedToCPF = Object.entries(res1?.pending_payslips)?.[0]?.[1]
        ?.is_proceed_to_cpf;
      let isResponseEmpty =
        Object.entries(res1?.payrun_finalized_payslips)?.length === 0;

      if (isResponseEmpty && isShowMore) {
        Notify(
          "You have reached the end of the page. No more data to fetch!",
          1
        );
      }
      if (isPayrunReady && isProceedToCPF) {
        Notify("CPF return is finalized, please proceed to create payrun", 1);
      }

      if (Object.keys(res1?.pending_payslips || {})?.length) {
        let dateStr = Object.entries(res1?.pending_payslips)?.[0]?.[0];
        if (dateStr.split("-")[1] === "01") {
          handleShowMore();
        }
      }

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const sendForApproval = async () => {
    setLoading(true);
    const dataToApprove = {
      company: companyId,
      payslip_date: dateToApprove,
    };

    try {
      const { status } = await EmployeeService._sendForApproval(dataToApprove);

      if (status >= 200 && status < 300) {
        Notify("Payslips Sent for Approval", 1);
        setIsAlreadySentToTellboss(() => true);
        setIsApprovalModalOpen(() => false);
        setLoading(false);
      }
    } catch (error: any) {
      if (error?.response?.data?.paylsip) {
        Notify(error?.response?.data?.paylsip, 0);
      } else {
        Notify(Constant.common.something_went_wrong, 0);
      }
      setLoading(false);
      setIsApprovalModalOpen(() => false);
    }
    // setIsApprovalModalOpen(() => false);
    setDateToApprove(() => "");
  };

  useEffect(() => {
    if (year) {
      get();
    }
  }, [year]);

  // const getAllAccountingData = async () => {
  //   try {
  //     const res = await PayrunService._getAllAccountingInfo(companyId,)
  //     console.log("theRes accounting", res.data.data)
  //     // setData(res.data.data);

  //   } catch (e:any) {
  //     console.error(e);
  //   }
  // }
  // useEffect(() => {
  //   if(companyId) {
  //     getAllAccountingData()
  //   }
  // }, [companyId]);

  const handleViewAndPreView = (data: any) => {
    setDataView(() => data);
    setPdfViewModal(() => true);
  };
  const handleOpenModal = (data: any[]) => {
    setFinalizedData(() => data);
    setOpen(true);
  };

  const handleUnFinalisation = async () => {
    setLoading(true);
    setOpen(false);
    try {
      const ids = finalizedData?.map((_) => _.id);
      const formData = new FormData();
      formData.append("finalize", "false");
      formData.append("payslip_ids", ids.join(","));
      formData.append("company", `${defaultCompanyId}`);
      const res = await PayrunService._bulkPayslipFinalize(formData);
      // setOpen(false);

      if (res.status >= 200 && res.status < 300) {
        // firebase log here
        let key = "unfinalize";
        let data = {
          user_id: user.id,
          name: user.name,
          // device_fingerprint: "using_client_js",
          event_date_time: moment().utc().format("DD/MM/YYYY hh:mm A"),
          platform: "web",
        };
        // logFirebaseEvent(key, data);
        microAgent.addPageAction(key, data);

        setData({});
      }

      // instead of calling get() here, just updating the year to currentYear to fetch the currenty year data
      setYear(currentPayrunDate?.split("-")?.[0]);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  console.log(!Object.keys(data?.payrun_finalized_payslips || {}));
  console.log(data.payrun_finalized_payslips === null);

  const handleShowMore = () => {
    setIsShowMore(true);
    let currentYear = parseInt(year);
    setYear(`${currentYear - 1}`);
  };

  const checkCPFReturnStatus = async () => {
    try {
      let res = await TellBossService._checkCPFReturnStatus(
        user.defaultCompnayId,
        Object.entries(data?.pending_payslips || [])?.map((x: any) => x[0])?.[0]
      );

      if (res.status >= 200 && res.status < 300) {
        setCpfReturnStatus(res?.data?.data?.is_cpf_return_finalized);

        if (!res?.data?.data?.is_cpf_return_finalized) {
          Notify("CPF return is not finalized yet", 0, { autoClose: false });
        }
      }
    } catch (e: any) {
      Notify(Constant.common.something_went_wrong, 0);
    }
  };

  const handleNavigate = () => {
    navigate("/dashboard/filing/monthly");
  };

  // console.log("Approval Date", Object.entries(data?.pending_payslips || [])?.map((x:any)=>x[0])?.[0])

  const getDateRange = (date: any) => {
    console.log("Date inside range", date);
    const month = moment(date).format("MMMM");
    const firstOfNextMonth = moment(date, "YYYY-MM-DD")
      .add(1, "month")
      .date(1)
      .format("DD-MM-YYYY");
    const tenthOfNextMonth = moment(date, "YYYY-MM-DD")
      .add(1, "month")
      .date(10)
      .format("DD-MM-YYYY");
    return `${firstOfNextMonth || ""} to ${tenthOfNextMonth || ""}`;
  };

  console.log(
    "theMonthTest",
    moment("05-12-2023", "DD-MM-YYYY").add(1, "month").format("DD-MM-YYYY")
  );

  if (!hasViewAccess) {
    return (
      <>
        <Navigate to="/dashboard/access-denied" />
      </>
    );
  }

  const processedData = Utils.cleanPayrunInProcessData(data?.pending_payslips);

  console.log("the processedData", processedData);

  const InfoTextContainer = () => {
    return <Box sx={{p:1, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                  
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Step 1 */}
        <Box sx={{  display: 'flex', flexDirection: 'column', gap: 1, flex: 1  }}>
          
          <Typography variant="subtitle1" sx={{ color: '#6c757d', fontWeight: 500, marginLeft: 1.25 }}>
            Step 1 - "Pay Runs" menu - Admin to click HERE to send "Finised" payslips to TellBoss App for Approval
          </Typography>
        </Box>

        {/* Step 2 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,  }}>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
            <Typography variant="subtitle1" sx={{ color: '#6c757d', fontWeight: 500, marginLeft: 1.25 }}>
              Step 2 - Go to "Payroll-TellBoss" menu to receive TellBoss approval OR Admin to approve
            </Typography>
            
          </Box>
        </Box>

        {/* Step 3 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          
          <Typography variant="subtitle1" sx={{ color: '#6c757d', fontWeight: 500, marginLeft: 1.25 }}>
            Step3 - "Pay Runs" menu - After received approval, click "Create PayRun" button
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          
          <Typography variant="subtitle1" sx={{ color: '#6c757d', fontWeight: 500, marginLeft: 1.25 }}>
            Step 4 - "Manage Employees" menu - Go and finalise more payslips and repeat Step 1 again
          </Typography>
        </Box>
      </Box>
    </Box>
  }

  

  return (
    <div
      style={{
        position: "relative",
        maxHeight: "92vh",
        overflow: "scroll",
      }}
    >
      {loading && <Loader />}
      <div className="company-header-wrap" style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "1rem",
        paddingBottom: '4px',
      }}>
        <h2>{Utils.getTitleWithCompanyName("Pay Runs")}</h2>

        <CustomTooltip title={<InfoTextContainer />} placement={'bottom-start'}>
        <PulsingIcon>
            <img src="/info-outline.svg" style={{ width: '25px', height: '25px' }} /> 
        </PulsingIcon>
        </CustomTooltip>
      </div>
      <Paper
        sx={{
          mb: "4px",
        }}
        elevation={3}
      >
        <Box sx={{ background: "#4a5e71", padding: "8px 16px" }}>
          <Typography color="white">Pending Pay Runs</Typography>
        </Box>

        {hasAddEditAccess && Object.entries(data?.pending_payslips || []).length > 0 &&
          Object.entries(data?.pending_payslips || [])?.map(
            (payrun: any, index: number) => (
              <PayrunBlock
                payrunData={payrun[1]}
                payrunDate={payrun[0]}
                key={String(index)}
                sendForApproval={sendForApproval}
                fetchData={get}
                loading={loading}
                setLoading={setLoading}
              />
            )
          )}

        {(hasAddEditAccess && Object.entries(data?.pending_payslips || []).length === 0 && !loading) && (
            <Box 
            sx={{ 
              p: 6,
              textAlign: 'center',
              borderRadius: '16px',
              margin: '1rem',
            }}
            >
            <Box
              sx={{
              mb: 3,
              p: 2,
              borderRadius: '50%',
              background: '#f1f3f5',
              width: '80px',
              height: '80px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
              }}
            >
              <Typography 
              sx={{ color: '#adb5bd' }}
              >
              <BsClipboard2MinusFill size={48} />
              </Typography>
            </Box>
            
            {/* <Typography 
              variant="h6" 
              sx={{ 
              color: '#495057',
              mb: 1,
              fontWeight: 500
              }}
            >
              No Active Payruns
            </Typography> */}
            
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#856404',
                backgroundColor: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '0.5rem',
                padding: '0.5rem 1.25rem',
                width: 'fit-content',
                margin: '0 auto',
                lineHeight: 1.6,
                textAlign: 'center',
                fontWeight: 600,
                fontSize: '1.25rem',
              }}
            >
              There are currently no finalized payslip for current payrun month.
            </Typography>

            <Button
              variant="contained"
              sx={{ 
                mt: 3,
                textTransform: 'none',
                fontSize: '0.875rem',
                fontWeight: 500,
                padding: '8px 16px',
                borderRadius: '8px',
                backgroundColor: '#059bbf',
                '&:hover': {
                  backgroundColor: '#047a9f',
                },
                color: '#ffffff',
              }}
              onClick={() => navigate("/dashboard/employee-payroll")}
            >
              Go to Manage Employees
            </Button>
            
            </Box>
        )}
      </Paper>

      {/* --------------------------------------- Finalized Payruns ------------------------------------- */}

      {hasViewAccess &&
        Object.entries(data?.payrun_finalized_payslips ?? [])?.map(
          (item: any, outerIndex: number) => (
            <div key={outerIndex}>
              {outerIndex > 0 && <hr style={{ margin: "0.5rem 0", height: "2px" }} />}
              <Typography 
                sx={{ 
                  mt: outerIndex === 0 ? 1 : 0, 
                  mb: 0,
                  fontSize: "1.25rem",
                  fontWeight: 600,
                  color: '#4a5e71'
                }}
                >
                {moment(item[0]).format('MMMM YYYY')}
              </Typography>
              {item?.[1]?.map((payrun: any, index: number) => (
                <FinalizedPayrun
                key={String(index)}
                payrun={[item[0], payrun]}
                companyName={companyName}
                currentPayrunDate={currentPayrunDate}
                />
              ))}
            </div>
          )
        )}

      {hasViewAccess && showFetchButton && (
        <div
          onClick={handleShowMore}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "0.5rem",
            // marginBottom: "1.5rem",
            cursor: "pointer",
            gap: "1rem",
            flexDirection: "column",
          }}
        >
          {loading && Object.keys(data)?.length > 1 ? (
            <TailSpin
              visible={true}
              height="60"
              width="60"
              color="#3498db"
              ariaLabel="tail-spin-loading"
              radius="1"
              wrapperStyle={{}}
              wrapperClass=""
            />
          ) : (
            <>
              <TfiDownload size={35} />
              <p
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                }}
              >
                Show More
              </p>
            </>
          )}
        </div>
      )}

      {/* </Container> */}
      <CommonModal
        handleClose={() => {
          setOpen(false);
        }}
        open={open}
        updateData={handleUnFinalisation}
        body={`${finalizedData?.length} payslip(s) will be unfinalised in bulk. Please only use
        this option if you need to change the majority of your payslips for
        the current period. If you are at all uncertain, we would
        strongly advise that you unfinalise payslips individually to prevent
        any unexpected changes. Are you sure you want to continue?`}
        loading={loading}
      />
      <CommonModal
        handleClose={() => setIsApprovalModalOpen(() => false)}
        open={isApprovalModalOpen}
        updateData={sendForApproval}
        body={`If Admin has finalized all the payslips then click "Confirm" icon`}
        heading={`Click "Confirm" to send payroll to "TellBoss" app`}
        conformButtonText="Confirm"
        cancelButtonText="Stop - Go to finalize payslips"
        loading={loading}
      />
      
    </div>
  );
}

export default Payrun;
